import { render, staticRenderFns } from "./AdvancedSelect.vue?vue&type=template&id=3840d4b2&"
import script from "./AdvancedSelect.vue?vue&type=script&lang=ts&"
export * from "./AdvancedSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports